import { render, staticRenderFns } from "./MyMind.vue?vue&type=template&id=6ca98887"
import script from "./MyMind.vue?vue&type=script&lang=js"
export * from "./MyMind.vue?vue&type=script&lang=js"
import style0 from "./MyMind.vue?vue&type=style&index=0&id=6ca98887&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports